<template>
  <PreciosSection />
  <InfoSection />
  <GuidanceSection />
</template>

<script>
import PreciosSection from '../Precios/PreciosSection.vue';
import InfoSection from '../Precios/InfoSection.vue';
import GuidanceSection from '../Precios/GuidanceSection.vue';

export default {
  name: 'PreciosIndex',
  components: {
    PreciosSection,
    InfoSection,
    GuidanceSection
  }
}
</script>